import { Role } from '@orderna/admin-panel/src/app/model/enum/role';
import { Status, WithStatus } from './enum/status';

export interface IUser extends WithStatus {
  id: number;
  role: Role;
  token: string;
  createdAt: Date;
  updatedAt: Date;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: {
    countryCode: string;
    number: string;
  };
  jobTitle: string;
  pin?: number;
  wageId?: number;
  zipCode?: string;
  city?: string;
  street?: string;
  isOnboardingCompleted: boolean;
  timezone?: string;
}

export const USER_FIELDS: (keyof IUser)[] = [
  'id',
  'role',
  'token',
  'createdAt',
  'updatedAt',
  'username',
  'password',
  'firstName',
  'lastName',
  'email',
  'mobile',
  'jobTitle',
  'pin',
  'wageId',
  'zipCode',
  'city',
  'street',
  'timezone',
];

export type UserCredentials = Pick<IUser, 'email' | 'password'>;
export type UserRegistrationData = UserCredentials &
  Pick<IUser, 'firstName' | 'lastName' | 'mobile' | 'jobTitle' | 'username'> & {
    company: string;
    subdomain: string;
  };

export class User implements IUser {
  constructor(
    public readonly id = 0,
    public readonly firstName = '',
    public readonly lastName = '',
    public readonly username = '',
    public readonly password = '',
    public readonly email = '',
    public readonly mobile = { countryCode: '', number: '' },
    public readonly role = Role.CASHIER,
    public readonly status = Status.ACTIVE,
    public readonly jobTitle = '',
    public readonly token = '',
    public readonly pin?: number,
    public isOnboardingCompleted = false,
    public readonly createdAt = new Date(),
    public readonly updatedAt = new Date(),
    public readonly wageId?: number,
    public readonly zipCode?: string,
    public readonly city = '',
    public readonly street = '',
    public readonly timezone?: string
  ) {}

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  static fromJSON(json: IUser) {
    return new User(
      json.id,
      json.firstName,
      json.lastName,
      json.username,
      json.password,
      json.email,
      json.mobile,
      json.role,
      json.status,
      json.jobTitle,
      json.token,
      json.pin,
      json.isOnboardingCompleted,
      json.createdAt,
      json.updatedAt,
      json.wageId,
      json.zipCode,
      json.city,
      json.street,
      json.timezone
    );
  }
}
